import { gql } from '@apollo/client'

export interface QueryVars {
  customerId: string
  subjectId: string
}

export interface VerifAIFlagResult {
  riskScore: number
  comment: string
}

export interface VerifAIFlagFeedback {
  helpful: boolean
  comment?: string
  userId: string
  createdAt: string
}

export interface VerifAIFlag {
  serviceName: string
  result: VerifAIFlagResult
  feedback: VerifAIFlagFeedback[]
}

export interface Response {
  getVerifAIFlags: {
    id: string
    flags: VerifAIFlag[]
  }
}

const query = gql`
  query ($customerId: String, $subjectId: String) {
    getVerifAIFlags(customerId: $customerId, subjectId: $subjectId) {
      id
      flags {
        serviceName
        result {
          riskScore
          comment
        }
        feedback {
          helpful
          comment
          userId
          createdAt
        }
      }
    }
  }
`

export default query
